<template>
    <div>
      <v-row v-if="risk == 'low' || risk == 'middle'" class="pa-2">
        <v-col>
          <h1>Монотерапия</h1>
          <v-divider></v-divider>
          <v-row align="start" align-content="space-between">
            <v-col cols="12" md="3" sm="3" lg="3" xl="3">
              <h3>Уточнить показания:</h3>
              <div class="clinical-conditions-wrapper">
                <v-checkbox
                  v-for="(clinicCond,index) in editionalClinicalConditions"
                  :key="index"
                  :label="clinicCond.name"
                  class="clinic-condition-item"
                  color="primary"
                  v-model="clinicCond.checked"
                  @change="toggleCheckBox(clinicCond, index)"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col cols="12" md="9" sm="9" lg="9" xl="9">
              <h3>Группы препаратов</h3>
              <v-expansion-panels multiple focusable inset v-model="panels">
                <v-expansion-panel v-for="(drugGroup) in drugGroups" :key="drugGroup.index" :disabled="drugGroup.state == 'inactive'">
                  <v-expansion-panel-header :class="drugGroup.state" :title="drugGroup.short + '. ' + drugGroupsTitles[drugGroup.state]">
                    <span class="title">
                      {{drugGroup.name}} ({{drugGroup.short}})
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <br>
                    <div v-if="drugGroup.description && drugGroup.description != ''">
                      <h4>Описание:</h4>
                      <div class="subtitle-1">{{drugGroup.description}}</div>
                    </div>
                    <div v-if="drugGroup.drugs && Object.keys(drugGroup.drugs).length > 0">
                      <h4>Препараты:</h4>
                      <div v-for="(drugSubGroup, index) in drugGroup.drugs" :key="index">
                        <div v-if="index != 'all'" class="subtitle-1 drug-sub-group-item" :class="drugSubGroup.disabled ? 'disabled' : ''">
                          <span class="subtitle-2 drug-sub-group-name">{{drugSubGroup.name}}:</span>{{drugSubGroup.list}}
                        </div>
                        <div v-else class="subtitle-1 drug-sub-group-item" :class="drugSubGroup.disabled ? 'disabled' : ''">{{drugSubGroup.list}}</div>
                      </div>
                    </div>
                    <div v-if="drugGroup.edditionalEffects && drugGroup.edditionalEffects != ''">
                      <h4>Дополнительные эффекты:</h4>
                      <div class="subtitle-1">{{drugGroup.edditionalEffects}}</div>
                    </div>
                    <div v-if="drugGroup.characteristics && drugGroup.characteristics != ''">
                      <h4>Особенности:</h4>
                      <div class="subtitle-1">{{drugGroup.characteristics}}</div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-divider></v-divider>
              <div style="margin-top: 20px;text-align: right">
                <v-btn color="primary" class="go-back-link"><router-link to="/">Назад</router-link></v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-else-if="risk == 'high' || risk == 'veryHigh'" class="pa-2">
        <v-col>
          <h1>Комбинированная терапия</h1>
          <v-divider></v-divider>
          <v-row align="start" align-content="space-between">
            <v-col cols="12" md="3" sm="3" lg="3" xl="3">
              <h3>Уточнить показания:</h3>
              <div class="clinical-conditions-wrapper">
                <v-checkbox
                  v-for="(clinicCond,index) in editionalClinicalConditions"
                  :key="index"
                  :label="clinicCond.name"
                  class="clinic-condition-item"
                  color="primary"
                  v-model="clinicCond.checked"
                  @change="toggleCheckBox(clinicCond, index)"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col cols="12" md="9" sm="9" lg="9" xl="9">
              <h3>Комбинации групп препаратов</h3>
              <v-pagination :length="drugGroupsCombinations.length" v-model="currentDrugGroupCombination"></v-pagination>
              <v-expansion-panels multiple focusable inset v-model="panels">
                <v-expansion-panel v-for="(drugGroup,index) in drugGroups"
                                   :key="index"
                                   :disabled="drugGroup.state == 'inactive'"
                                   :class="{'invisible': isGroupInCurrentCombination(index)}"
                >
                    <v-expansion-panel-header :class="drugGroup.state" :title="drugGroup.short + '. ' + drugGroupsTitles[drugGroup.state]">
                    <span class="title">
                      {{drugGroup.name}} ({{drugGroup.short}})
                    </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <br>
                      <div v-if="drugGroup.description && drugGroup.description != ''">
                        <h4>Описание:</h4>
                        <div class="subtitle-1">{{drugGroup.description}}</div>
                      </div>
                      <div v-if="drugGroup.drugs && Object.keys(drugGroup.drugs).length > 0">
                        <h4>Препараты:</h4>
                        <div v-for="(drugSubGroup, index) in drugGroup.drugs" :key="index">
                          <div v-if="index != 'all'" class="subtitle-1 drug-sub-group-item" :class="drugSubGroup.disabled ? 'disabled' : ''">
                            <span class="subtitle-2 drug-sub-group-name">{{drugSubGroup.name}}:</span>{{drugSubGroup.list}}
                          </div>
                          <div v-else class="subtitle-1 drug-sub-group-item" :class="drugSubGroup.disabled ? 'disabled' : ''">{{drugSubGroup.list}}</div>
                        </div>
                      </div>
                      <div v-if="drugGroup.edditionalEffects && drugGroup.edditionalEffects != ''">
                        <h4>Дополнительные эффекты:</h4>
                        <div class="subtitle-1">{{drugGroup.edditionalEffects}}</div>
                      </div>
                      <div v-if="drugGroup.characteristics && drugGroup.characteristics != ''">
                        <h4>Особенности:</h4>
                        <div class="subtitle-1">{{drugGroup.characteristics}}</div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
              </v-expansion-panels>
              <v-divider></v-divider>
              <div style="margin-top: 20px;text-align: right">
                <v-btn color="primary" class="go-back-link"><router-link to="/">Назад</router-link></v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-else class="pa-2">
        <v-col>
          <h1>Медикаментозная терапия</h1>
          <v-divider></v-divider>
          <h2>Медикаментозная терапия подразумевает:</h2>
          <p>
            <span class="headline">Низкий/Средний риск:</span> монотерапия
          </p>
          <p>
            <span class="headline">Высокий/очень высокий риск:</span> комбинация препаратов
          </p>
          <v-divider></v-divider>
          <h3>Группы препаратов:</h3>
          <div>
            <p><span class="headline">БРА</span> – блокаторы рецепторов к ангиотензину (валсартан, лозартан, кандесартан, телмисартан)</p>
            <p><span class="headline">ИАПФ</span> – ингибиторы ангиотензинпревращающего фермента (периндоприл, рамиприл, лизиноприл, эналаприл)</p>
            <p><span class="headline">АК</span> – антагонисты кальция (амлодипин, леркандипин, верапамил, нифедипин)</p>
            <p><span class="headline">ББ</span> – бета-блокаторы (бисопролол, небиволол, бетаксолол)</p>
            <p><span class="headline">Диуретики</span> (индапамид, гидролортиазид)</p>
          </div>
          <v-divider></v-divider>
          <h3>Рациональные комбинации антигипертензивных препаратов:</h3>
          <ul>
            <li>ИАПФ + диуретик</li>
            <li>БРА + диуретик</li>
            <li>ИАПФ + АК</li>
            <li>БРА + АК</li>
            <li>дигидропиридиновый АК + ББ</li>
            <li>АК + диуретик</li>
            <li>ББ + диуретик</li>
          </ul>
          <v-divider></v-divider>
          <div style="margin-top: 20px">
            <v-btn color="primary" class="go-back-link"><router-link to="/">Назад</router-link></v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'DrugTherapy',
  data: () => {
    return {
      risk: '',
      panels: [],
      editionalClinicalConditions: {
        1: {
          name : 'двусторонний стеноз почечных артерий',
          // contraindicatedDrugGroups: ['iApf.drugs.all', 'bra.drugs.all'],
          contraindicatedDrugGroups: {
              groupNames: {
                partial: false,
                fully: ['iApf', 'bra']
              },
              drugs: ['iApf.drugs.all', 'bra.drugs.all']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        2: {
          name : 'ангионевротический отек',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['iApf', 'bra']
            },
            drugs: ['iApf.drugs.all', 'bra.drugs.all']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        3: {
          name : 'ХСН, сниженная ФВ ЛЖ',
          contraindicatedDrugGroups: {
            groupNames: {
                partial: ['akk'],
                fully: false
            },
            drugs: ['akk.drugs.fenilalkilamin','akk.drugs.benzodiazepin']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        4: {
          name : 'атриовентрикулярная блокада 2-3 степени',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['akk', 'bb']
            },
            drugs: ['akk.drugs.fenilalkilamin','akk.drugs.benzodiazepin','akk.drugs.degidropiridin','bb.drugs.nonSelective','bb.drugs.adrenoSelective']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        5: {
          name : 'бронхиальная астма',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['bb']
            },
            drugs: ['bb.drugs.nonSelective','bb.drugs.adrenoSelective']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        6: {
          name : 'изолированная систолическая АГ',
          contraindicatedDrugGroups: false,
          recommendedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['akk']
            },
            drugs: ['akk.drugs.fenilalkilamin','akk.drugs.benzodiazepin','akk.drugs.degidropiridin']
          },
          checked: false
        },
        7: {
          name : 'подагра',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: ['diuretics'],
              fully: false
            },
            drugs: ['diuretics.drugs.tiazid']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        8: {
          name : 'СД',
          contraindicatedDrugGroups: false,
          recommendedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['iApf', 'bra']
            },
            drugs: ['iApf.drugs.all', 'bra.drugs.all']
          },
          checked: false
        },
        9: {
          name : 'ИБС',
          contraindicatedDrugGroups: false,
          recommendedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['iApf','bra','bb','akk']
            },
            drugs: ['iApf.drugs.all', 'bra.drugs.all', 'bb.drugs.nonSelective','bb.drugs.adrenoSelective','akk.drugs.fenilalkilamin','akk.drugs.benzodiazepin','akk.drugs.degidropiridin']
          },
          checked: false
        },
        10: {
          name : 'беременность',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['iApf','bra']
            },
            drugs: ['iApf.drugs.all', 'bra.drugs.all']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        11: {
          name : 'гиперкалиемия',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: ['diuretics'],
              fully: ['iApf','bra']
            },
            drugs: ['iApf.drugs.all', 'bra.drugs.all', 'diuretics.drugs.caliySaving']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        12: {
          name : 'гипокалиемия',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: ['diuretics'],
              fully: false
            },
            drugs: ['diuretics.drugs.tiazid']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        13: {
          name: 'AV-блокада',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: ['akk'],
              fully: ['bb']
            },
            drugs: ['bb.drugs.nonSelective','bb.drugs.adrenoSelective', 'akk.drugs.fenilalkilamin','akk.drugs.fenilalkilamin','akk.drugs.benzodiazepin']
          },
          recommendedDrugGroups: false,
          checked: false
        },
        14: {
          name: 'Сухой кашель',
          contraindicatedDrugGroups: {
            groupNames: {
              partial: false,
              fully: ['iApf']
            },
            drugs: ['iApf.drugs.all']
          },
          recommendedDrugGroups: false,
          checked: false
        }
      },
      drugGroupsTitles: {
        'active': 'Допустимая группа препаратов.',
        'partial-active': 'Частично противопоказанная группа препаратов',
        'inactive': 'Полностью противопоказанная группа препаратов',
        'recommended': 'Рекомендованная группа препаратов',
        'partial-recommended': 'Частично-рекомендованная группа препаратов',
      },
      drugGroups: {
        iApf: {
          index: 0,
          name: 'Ингибиторы АПФ',
          short: 'иАПФ',
          description: 'Блокируют превращение ангиотензина I в биологически активный ангиотензин II.',
          drugs: {
            all: {
              list: 'лизиноприл. эналаприл, периндоприл, рамиприл, фозиноприл и др.',
              disabled: false,
            }
          },
          edditionalEffects: 'кардиопротективный, нефропротективный, антиатеросклеротический, противодиабетический.',
          contraindications: [10,11,1,2,14],
          characteristics: 'более эффективны у молодых, чем у пожилых людей; регулярный прием НПВС снижает эффективность',
          state: 'active', //  другие варанты partial-active inactive partial-recommended recommended
        },
        bra: {
          index: 1,
          name: 'Блокаторы рецепторов к ангиотензину',
          short: 'БРА',
          description: 'Блокируют рецепторы к ангиотензину II.',
          drugs: {
            all: {
              list: 'валсартан, лозартан, телмисартан, кандесартан и др.',
              disabled: false,
            }
          },
          edditionalEffects: 'кардиопротективный, нефропротективный, противодиабетический.',
          contraindications: [1,2,10,11],
          characteristics: false,
          state: 'active' //  другие варанты partial-active inactive
        },
        akk: {
          index: 2,
          name: 'Антагонисты кальциевых каналов',
          short: 'АКК',
          description: 'Замедляют ток Са через кальциевые каналы периферических сосудов, уменьшают чувствительность артериальных сосудов к эндогенным влияниям прессорных аминов',
          drugs: {
            degidropiridin: {
                list: 'нифедипин, фелодипин, амлодипин, лацидипин',
                name: 'производные дигидропиридина',
                disabled: false,
            },
            fenilalkilamin: {
                list: 'верапамил',
                name: 'производные фенилалкиламина',
                disabled: false
            },
            benzodiazepin: {
                list: 'дилтиазем',
                name: 'производные бензодиазепина',
                disabled: false,
            },
          },
          edditionalEffects: 'антиангинальный/антиишемический, антиатерогенный, антиаритмический в виде удлинения QT (недигидропиридиновые), органопротективный (в большей мере дигидропиридиновые)',
          contraindications: [3,13],
          characteristics: 'Более эффективны у пожилых людей, препарат первого выбора при изолированной систолической артериальной гипертензии.',
          state: 'active' //  другие варанты partial-active inactive
        },
        bb: {
          index: 3,
          name: 'Бета адреноблокаторы',
          short: 'ББ',
          description: 'Блокируют β-адренорецепторы, уменьшают адренергическое влияние на сердце',
          drugs: {
            nonSelective: {
              list: 'пропранолол, надолол, окспренолол, соталол, тимолол и др.',
              name: 'неселективные',
              disabled: false,
            },
            adrenoSelective: {
              list: 'атенолол, бетаксолол, бисопролол, метопролол и др.',
              name: 'бета адреноселективные',
              disabled: false,
            }
          },
          edditionalEffects: 'антиангинальный/антиишемический, антиаритмический.',
          contraindications: [5,13],
          characteristics: 'менее эффективны у пожилых людей, рекомендовано у коморбидных пациентов, необходима постепенная отмена.',
          state: 'active' //  другие варанты partial-active inactive
        },
        diuretics: {
          index: 4,
          name: 'Диуретики',
          short: 'ДИУРЕТИКИ',
          description: 'Стимулируют диурез, снижают ОЦК',
          drugs: {
            tiazid: {
              list: 'гидрохлоротиазид, хлорталидон, индапамид, метозалон',
              name: 'тиазидные и тиазидоподобные',
              disabled: false,
            },
            looped: {
              list: 'фуросемид, торасемид, этакриновая кислота',
              name: 'петлевые',
              disabled: false,
            },
            caliySaving: {
              list: 'антагонисты альдостерона (спиронолактон, эплеренон), неантагонисты альдостерона (амилорид, триамтерен)',
              name: 'калийсберегающие',
              disabled: false,
            }
          },
          edditionalEffects: 'эффективны в качестве стартовой терапии при высоком АД.',
          contraindications: [],
          characteristics: false,
          state: 'active' //  другие варанты partial-active inactive
        },
      },
      drugGroupsCombinations: [
        ['iApf','diuretics'],
        ['iApf','akk'],
        ['bra','diuretics'],
        ['bra','akk'],
        ['bb','diuretics'],
        ['akk','diuretics'],
        ['akk','bb'],
      ],
      currentDrugGroupCombination: 1,
      checkedClinicalConditions: []
    }
  },
  methods: {
    isGroupInCurrentCombination(drugGroupKey) {
      return this.drugGroupsCombinations[this.currentDrugGroupCombination - 1].indexOf(drugGroupKey) == -1
    },
    initDrugGroups () {
      let keys = Object.keys(this.drugGroups)
      for (let key in keys) {
        let drugGroup = this.drugGroups[keys[key]]
        drugGroup.state = 'active'
        let drugsKeys = Object.keys(drugGroup.drugs)
        for (let i in drugsKeys) {
          let drug = drugGroup.drugs[drugsKeys[i]]
          drug.disabled = false
        }
      }
    },
    combineCheckboxes () {
      //Объеденить все противопоказания и рекомендации с учетом ВСЕХ чекнутых показаний
      let markedClinicalConditions = this.checkedConditions
      // скелет итогового объекта
      let result = {
        contraindicatedDrugGroups: {
          groupNames: {
            partial: [],
            fully: []
          },
          drugs: []
        },
        recommendedDrugGroups: {
          groupNames: {
            partial: [],
            fully: []
          },
          drugs: []
        },
      }
      let keys = Object.keys(markedClinicalConditions)
      for (let key in keys) {
        var cCondition = markedClinicalConditions[keys[key]]
        // противопоказанные группы препаратов
        if (cCondition.hasOwnProperty('contraindicatedDrugGroups') && cCondition.contraindicatedDrugGroups !== false) {
          var contraindicatedDrugs = cCondition.contraindicatedDrugGroups.drugs
          if (contraindicatedDrugs !== false && contraindicatedDrugs.length > 0) {
            // merge массивов
            result.contraindicatedDrugGroups.drugs = [... new Set([...contraindicatedDrugs,...result.contraindicatedDrugGroups.drugs])]
          }
          if (cCondition.contraindicatedDrugGroups != false) {
            var contraindicatedGroups = cCondition.contraindicatedDrugGroups.groupNames
            if (contraindicatedGroups.partial !== false && contraindicatedGroups.partial.length > 0) {
              result.contraindicatedDrugGroups.groupNames.partial = [... new Set([...contraindicatedGroups.partial,...result.contraindicatedDrugGroups.groupNames.partial])]
            }
            if (contraindicatedGroups.fully !== false && contraindicatedGroups.fully.length > 0) {
              result.contraindicatedDrugGroups.groupNames.fully = [... new Set([...contraindicatedGroups.fully,...result.contraindicatedDrugGroups.groupNames.fully])]
            }
          }
        }
        // рекомендованные группы препаратов
        if (cCondition.hasOwnProperty('recommendedDrugGroups') && cCondition.recommendedDrugGroups !== false) {
          var recommendedDrugs = cCondition.recommendedDrugGroups.drugs
          if (recommendedDrugs !== false && recommendedDrugs.length > 0) {
            result.recommendedDrugGroups.drugs = [... new Set([...recommendedDrugs,...result.recommendedDrugGroups.drugs])]
          }
          if (cCondition.recommendedDrugGroups != false) {
            var recommendedGroups = cCondition.recommendedDrugGroups.groupNames
            if (recommendedGroups.partial !== false && recommendedGroups.partial.length > 0) {
              result.recommendedDrugGroups.groupNames.partial = [... new Set([...recommendedGroups.partial,...result.recommendedDrugGroups.groupNames.partial])]
            }
            if (recommendedGroups.fully !== false && recommendedGroups.fully.length > 0) {
              result.recommendedDrugGroups.groupNames.fully = [... new Set([...recommendedGroups.fully,...result.recommendedDrugGroups.groupNames.fully])]
            }
          }
        }
      }
      // чистка итогового объекта
      if (result.contraindicatedDrugGroups.drugs.length == 0) {
        result.contraindicatedDrugGroups.drugs = false
      }
      if (result.contraindicatedDrugGroups.groupNames.fully.length == 0) {
        result.contraindicatedDrugGroups.groupNames.fully = false
      }
      if (result.contraindicatedDrugGroups.groupNames.partial.length == 0) {
          result.contraindicatedDrugGroups.groupNames.partial = false
      }
      if (result.contraindicatedDrugGroups.groupNames.partial == false && result.contraindicatedDrugGroups.groupNames.fully == false) {
        result.contraindicatedDrugGroups.groupNames = false
      }
      if (result.contraindicatedDrugGroups.drugs == false && result.contraindicatedDrugGroups.groupNames == false) {
          result.contraindicatedDrugGroups = false
      }
      if (result.recommendedDrugGroups.drugs.length == 0) {
        result.recommendedDrugGroups.drugs = false
      }
      if (result.recommendedDrugGroups.groupNames.fully.length == 0) {
        result.recommendedDrugGroups.groupNames.fully = false
      }
      if (result.recommendedDrugGroups.groupNames.partial.length == 0) {
        result.recommendedDrugGroups.groupNames.partial = false
      }
      if (result.recommendedDrugGroups.groupNames.fully == false && result.recommendedDrugGroups.groupNames.partial == false) {
          result.recommendedDrugGroups.groupNames = false
      }
      if (result.recommendedDrugGroups.groupNames == false && result.recommendedDrugGroups.drugs == false) {
          result.recommendedDrugGroups = false
      }
      return result
    },
    specify () {
      let clinicalCondition = this.combineCheckboxes()
      clinicalCondition.checked = true
      this.initDrugGroups()
      //первыми обработать рекомендованные группы препаратов
      if (clinicalCondition.recommendedDrugGroups != false) {
        let recommendedDrugsList = clinicalCondition.recommendedDrugGroups.drugs
        let recommendedGroups = clinicalCondition.recommendedDrugGroups.groupNames
        for (let k in recommendedDrugsList) {
          var cmdString = 'this.drugGroups.' + recommendedDrugsList[k] + '.disabled = false'
          // cmdString += clinicalCondition.checked ? 'true' : 'false'
          eval(cmdString)
        }
        if (recommendedGroups.partial != false) {
          for (let k in recommendedGroups.partial) {
            let stateName = clinicalCondition.checked ? 'partial-recommended' : 'active'
            this.drugGroups[recommendedGroups.partial[k]].state = stateName
          }
        }
        if (recommendedGroups.fully != false) {
          for (let k in recommendedGroups.fully) {
            let stateName = clinicalCondition.checked ? 'recommended' : 'active'
            this.drugGroups[recommendedGroups.fully[k]].state = stateName
          }
        }
      }
      // противопоказанные группы могут переопределить рекомендации. Противопоказания важнее
      if (clinicalCondition.contraindicatedDrugGroups != false) {
        let prohibitedDrugsList = clinicalCondition.contraindicatedDrugGroups.drugs
        let prohibitedGroups = clinicalCondition.contraindicatedDrugGroups.groupNames
        for (let k in prohibitedDrugsList) {
          var cmdString = 'this.drugGroups.' + prohibitedDrugsList[k] + '.disabled = '
          cmdString += clinicalCondition.checked ? 'true' : 'false'
          eval(cmdString)
        }
        if (prohibitedGroups.partial != false) {
          for (let k in prohibitedGroups.partial) {
            let stateName = clinicalCondition.checked ? 'partial-active' : 'active'
            this.drugGroups[prohibitedGroups.partial[k]].state = stateName
          }
        }
        if (prohibitedGroups.fully != false) {
          for (let k in prohibitedGroups.fully) {
            let stateName = clinicalCondition.checked ? 'inactive' : 'active'
            let groupName = prohibitedGroups.fully[k]
            if (clinicalCondition.checked) {
              // свернуть распахнутые если есть
              let groupIndex = this.drugGroups[groupName].index
              let indexInArr = this.panels.indexOf(groupIndex)
              if (indexInArr !== -1) {this.panels.splice(indexInArr,1)}
            }
            this.drugGroups[groupName].state = stateName
          }
        }
      }
    },
    toggleCheckBox (clinicalCondition,index) {
      if (clinicalCondition.checked) {
        this.checkedClinicalConditions.push(index)
      } else {
        let arrIndex = this.checkedClinicalConditions.indexOf(index)
        if (arrIndex !== -1) {
            this.checkedClinicalConditions.splice(arrIndex,1)
        }
      }
    }
  },
  computed: {
    checkedConditions() {
      let keys = Object.keys(this.editionalClinicalConditions)
      let filteredConditions = {}
      for (var key in keys) {
        var item = this.editionalClinicalConditions[keys[key]]
        if (item.checked === true) {
          filteredConditions[key] = item
        }
      }
      return filteredConditions
    },
    drugGroupsCombination() {
      var result = {}
      let groupsToAdd = this.drugGroupsCombination[this.currentDrugGroupCombination - 1]
      for (let index in groupsToAdd) {
        let groupName = groupsToAdd[index]
        result[groupName] = this.drugGroups[groupName]
      }
      return result
    }
  },
  watch: {
    '$route' (to, from) {
      this.risk = to.params.risk
    },
    checkedClinicalConditions (newValue, oldValue) {
      this.specify()
    }
  },
  created() {
    this.risk = this.$route.params.risk
  }
}
</script>

<style scoped lang="scss">
  h1{
    margin-bottom: 20px;
  }
  h3{
    margin: 10px 0px 20px 0px;
  }
  .go-back-link {
    span {
      a {
        color: white;
        text-decoration: none;
      }
    }
  }
  h1 {
    text-align: center;
  }
  h2{
    text-align: center;
    padding: 10px 0px;
    background: rgba(0,0,0,0.03);
  }
  h3 {
    text-align: center;
    border-bottom: 1px dashed rgba(0,0,0,0.2);
    padding-bottom: 10px;
  }
  .group-item {
    text-align: center;
    padding: 10px;
    background: rgba(0,0,0,0.05);
    border-radius: 5px;
    border: 1px dashed rgba(0,0,0,0.2);
  }
  .drug-sub-group-item {
    .drug-sub-group-name {
      font-size: 16px!important;
      font-weight: 600;
      text-decoration: underline;
      margin-right: 5px;
    }
    &.disabled {
      text-decoration: line-through;
    }
  }
  .v-expansion-panel-header.active,
  .v-expansion-panel-header.partial-active,
  .v-expansion-panel-header.inactive,
  .v-expansion-panel-header.recommended,
  .v-expansion-panel-header.partial-recommended {
    &:after {
      display: inline-block;
      font: normal normal normal 24px/1 "Material Design Icons";
      font-size: inherit;
      text-rendering: auto;
      line-height: inherit;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-size: 1.5rem;
    }
  }
  .v-expansion-panel-header.active {
    color: #4caf50;
    &:after {
      /*content: "\F419";*/
    }
  }
  .v-expansion-panel-header.partial-active {
    color: #8bc34a;
    &:after {
      content: "\F12D";
      color:#78909c;
    }
  }
  .v-expansion-panel-header.inactive {
    text-decoration: line-through;
  }
  .v-expansion-panel-header.recommended {
    color: #009688;
    &:after {
      content: "\F12D";
    }
  }
  .v-expansion-panel-header.partial-recommended {
    color: #4db6ac;
  }
  .v-expansion-panel-header.recommended + div.v-expansion-panel-content {
    .drug-sub-group-item {
      color: #009688;
    }
  }
  .v-expansion-panel.invisible {
    display: none;
  }
</style>
<style lang="scss">
  .clinic-condition-item {
    margin: 0px;
    .v-input__control {
      .v-input__slot {
        margin: 0px!important;
      }
      .v-messages {
        min-height: 5px!important;
      }
    }
  }
</style>
